import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { FAQS } from "@/data/faq";
import useSEO from "@/hooks/useSEO";

// FAQ section — AEO/GEO-optimized (FAQPage JSON-LD makes it eligible
// for ChatGPT citations and Google's AI Overviews / rich snippets).
export default function FAQSection() {
    const [openIdx, setOpenIdx] = useState(0);

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
    };
    useSEO({ jsonLd });

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="py-20 md:py-32 scroll-mt-24"
        >
            <div className="max-w-5xl mx-auto px-6 md:px-12">
                <div className="max-w-2xl mb-12">
                    <div className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-[#3D8C95] mb-4">
                        <HelpCircle size={14} />
                        <span>Questions fréquentes</span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2C2A29] tracking-tight leading-tight">
                        Vos questions,{" "}
                        <span className="italic text-[#E07A5F]">nos réponses</span>.
                    </h2>
                    <p className="mt-4 text-[#6E6862] leading-relaxed text-base md:text-lg">
                        Prix, techniques, contre-indications, réservation — tout ce que vous devez savoir avant votre première séance.
                    </p>
                </div>

                <div className="space-y-3">
                    {FAQS.map((f, i) => {
                        const open = openIdx === i;
                        return (
                            <div
                                key={i}
                                data-testid={`faq-item-${i}`}
                                className={`rounded-2xl border transition-all duration-300 ${
                                    open ? "bg-white border-[#3D8C95]/40 shadow-[0_8px_30px_rgba(44,42,41,0.06)]" : "bg-white/60 border-[#E8E2D9]"
                                }`}
                            >
                                <button
                                    type="button"
                                    onClick={() => setOpenIdx(open ? -1 : i)}
                                    className="w-full text-left px-6 py-5 flex items-center justify-between gap-4"
                                    data-testid={`faq-toggle-${i}`}
                                >
                                    <span className="font-display text-base md:text-lg text-[#2C2A29] flex-1">
                                        {f.q}
                                    </span>
                                    <ChevronDown
                                        size={20}
                                        className={`text-[#3D8C95] flex-shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
                                    />
                                </button>
                                {open && (
                                    <div className="px-6 pb-6 -mt-1">
                                        <p className="text-sm md:text-base text-[#6E6862] leading-relaxed">
                                            {f.a}
                                        </p>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
